// Artwork exported from the Figma section "Tournaments Elements" (2864:14973) on the PAVEL DRAFT
// page, via the Dev Mode asset server. The PNGs were downsized to 3x their drawn size and the SVGs
// lost their root width/height so svgr keeps the viewBox and they scale.
import ChipBluePng from './chip-blue.png';
import ChipRedPng from './chip-red.png';
import ChipStackPng from './chip-stack.png';
import IconClockSvg from './icon-clock.svg';
import IconClockSmallSvg from './icon-clock-small.svg';
import IconInfoSvg from './icon-info.svg';
import IconTrophySvg from './icon-trophy.svg';
import TierBlueBgPng from './tier-blue-bg.png';
import TierGoldBgPng from './tier-gold-bg.png';
import TierPurpleBgPng from './tier-purple-bg.png';
import TimerDividerSvg from './timer-divider.svg';
import TrophyBronzePng from './trophy-bronze.png';
import TrophyGoldPng from './trophy-gold.png';
import TrophySilverPng from './trophy-silver.png';

export {
	ChipBluePng,
	ChipRedPng,
	ChipStackPng,
	IconClockSmallSvg,
	IconClockSvg,
	IconInfoSvg,
	IconTrophySvg,
	TierBlueBgPng,
	TierGoldBgPng,
	TierPurpleBgPng,
	TimerDividerSvg,
	TrophyBronzePng,
	TrophyGoldPng,
	TrophySilverPng,
};
